import { QueryState } from "src/app/core/models/query.model";
import { createTokenQueryServiceInstance } from "src/app/core/services/query-sentrynel.service";
import { SignalStoreConfig } from "src/app/shared/functions/store.functions";

export const ARERA_ENDPOINT = 'arera';
export const ARERA_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(ARERA_ENDPOINT);


export const areraStateConfig: SignalStoreConfig<QueryState<any>> = {
    initState: {
      list: []
    }
  }
